<template>

  <b-row>
    <b-col>
      <b-card style="margin:0;border:1px solid #2980b9;padding:0 10px" no-body :class="{ 'open': visibleBody }">
        <b-card-header :class="{ 'collapsed': !visibleBody }" :aria-expanded="visibleBody ? 'true' : 'false'" role="tab"
          data-toggle="collapse" @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;">
          <span class="lead collapse-title">
            <strong>ANTECEDENTES FAMILIARES</strong>
          </span>

          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>
        <b-collapse v-model="visibleBody" role="tabpanel">

          <b-card-body style="padding: 1.5rem">

            <b-alert show class="mb-3 p-2">

              <h5 class="mb-1">HISTORIAL</h5>


              <span v-if="lastAntFamiliares && lastAntFamiliares.length">

                <div class="row" v-for="(lastAntFamiliar, index) in lastAntFamiliares" :key="lastAntFamiliar.rowKey || lastAntFamiliar.recordId || lastAntFamiliar.id"
                  v-if="lastAntFamiliar.estado === '1' || lastAntFamiliar.estado === 1">
                  <h6 class="col-3">{{ lastAntFamiliar.text }}</h6>
                  <h6 class="col-2">{{ lastAntFamiliar.familiar && lastAntFamiliar.familiar.length ?
                    lastAntFamiliar.familiar[0].text : "" }}</h6>
                  <h6 class="col-4">{{ lastAntFamiliar.inputText }}</h6>
                  <div class="col-1">
                    <button class="btn btn-warning btn-sm"
                      @click="editarAntecedente(lastAntFamiliar.recordId, lastAntFamiliar.value, lastAntFamiliar.text)">
                      <i class="fa-solid fa-pen"></i>
                    </button>
                  </div>
                  <div class="col-1">
                    <button class="btn btn-danger btn-sm" @click="eliminarAntecedente(lastAntFamiliar.recordId)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                  <hr class="col-11 mt-0">
                </div>
              </span>

              <span v-if="lastAntFamiliares && !lastAntFamiliares.length && !loadingHistorial">

                <h4 class="text-center">
                  <i class="fas fa-box-open" />
                  No exite historial
                </h4>
              </span>

              <b-skeleton-wrapper v-if="loadingHistorial">
                <b-skeleton v-for="i in 3" :key="i" width="100%" height="20px" />
              </b-skeleton-wrapper>

            </b-alert>

            <div v-if="lastAntFamiliares && !lastAntFamiliares.length" class="d-flex justify-content-end mr-2 mb-1">
              <b-form-checkbox v-model="noRefiere" switch>
                <label for="">No Refiere</label>
              </b-form-checkbox>
            </div>

            <div v-if="!noRefiere">
              <hr>

              <div>
                <label for="">Seleccionar antecedentes familiares:</label>
                <v-select class="mb-2" placeholder="Seleccione una o mas opciones" :options="antFamiliaresOpts"
                  :reduce="option => option" label="text" :multiple="true" v-model="antFamiliaresVSelect" />
              </div>



              <div v-for="(antFamiliar) in antFamiliaresItems" :key="antFamiliar.rowKey" class="row mb-2">
                <div class="col-sm-12 d-flex align-items-center">
                  <label>{{ antFamiliar.text }}</label>
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0 ml-2"
                    @click="duplicarAntecedente(antFamiliar)"
                  >
                    Duplicar
                  </button>
                </div>

                <div class="col-5">

                  <v-select placeholder="Familiar" :options="familiaresOpts" :reduce="option => option" label="text"
                    :multiple="true" taggable v-model="antFamiliar.familiar"
                    @input="newArray => antFamiliar.familiar = onAddNewOpt(newArray)" />
                </div>

                <div class="col-sm-7">
                  <b-form-input v-model="antFamiliar.inputText" placeholder="Describa los antecedentes familiares..."
                    type="text" />
                </div>
              </div>

              <!-- <div>
                <b-form-checkbox
                  v-model="observaciones.active"
                >
                  <label for="">Observaciones Adicionales:</label>
                </b-form-checkbox>

                <b-form-textarea
                  v-if="observaciones.active"
                  v-model="observaciones.text"
                />
              </div> -->
            </div>

            <div class="my-1">
              <hr>
              <p v-html="summaryText.html" />
            </div>

            <b-form-group class="mt-1">
              <b-button @click="copyAS400" variant="info">
                AS400 <i class="fas fa-copy" />
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>


    <b-toast id="my-toast2" variant="success" auto-hide-delay="6000" solid>
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">

          <strong class="mr-auto">Antecedentes familiares cargados</strong>
          <small class="text-muted mr-2">Hace 2 segundos</small>
        </div>
      </template>
      Antecedentes familiares de la cita anterior de este paciente.
    </b-toast>
  </b-row>

</template>

<script>
import vSelect from "vue-select";
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { addNewOpt, convertToSnakeCase, copyText } from '@/shared/helpers';
import { BToast } from "bootstrap-vue";
import { mapState } from 'vuex';
import { antFamiliaresService } from "../../../atencionMedica/services/antFamiliaresService";

export default {
  name: "AntecedentesFamiliares",

  components: {
    vSelect,
    BToast
  },
  props: {
    idPaciente: {
      type: [String, Number, Boolean, Object, Array, Function],
      default: null // Valor por defecto si no se proporciona
    },
    isEditar: {
      default: false,
      required: false
    }


  },
  created() {
    this.getAntFamiliaresOpts();
  },


  data() {
    return {
      nextRowKey: 0,
      cargoUnaVez: false,
      lastAntFamiliares: [],
      loadingHistorial: false,

      visibleBody: false,

      noRefiere: false,
      antFamiliaresOpts: [],
      antFamiliaresVSelect: [],
      antFamiliaresItems: [],

      observaciones: {
        active: false,
        text: ''
      },

      dataState: {
        noRefiere: false,
        items: [],
        observaciones: {
          active: false,
          text: ''
        }
      },

      familiaresOpts: [
        { value: 'padre', text: 'Padre' },
        { value: 'madre', text: 'Madre' },
        { value: 'abuelo_paterno', text: 'Abuelo paterno' },
        { value: 'abuela_paterna', text: 'Abuela paterna' },
        { value: 'abuelo_materno', text: 'Abuelo materno' },
        { value: 'abuela_materna', text: 'Abuela materna' },
        { value: 'hijo', text: 'Hijo' },
        { value: 'hija', text: 'Hija' },
        { value: 'hermano', text: 'Hermano' },
        { value: 'hermana', text: 'Hermana' },
        { value: 'tio_paterno', text: 'Tío paterno' },
        { value: 'tia_paterna', text: 'Tía paterna' },
        { value: 'tio_materno', text: 'Tío materno' },
        { value: 'tia_materna', text: 'Tía materna' },
        { value: 'primo', text: 'Primo' },
        { value: 'prima', text: 'Prima' },
        { value: 'sobrino', text: 'Sobrino' },
        { value: 'sobrina', text: 'Sobrina' },
        { value: 'nieto', text: 'Nieto' },
        { value: 'nieta', text: 'Nieta' },
        { value: 'padrastro', text: 'Padrastro' },
        { value: 'madrastra', text: 'Madrastra' },
        { value: 'hijastro', text: 'Hijastro' },
        { value: 'hijastra', text: 'Hijastra' },
        { value: 'cuñado', text: 'Cuñado' },
        { value: 'cuñada', text: 'Cuñada' },
        { value: 'suegro', text: 'Suegro' },
        { value: 'suegra', text: 'Suegra' },
        { value: 'yerno', text: 'Yerno' },
        { value: 'nuera', text: 'Nuera' }
      ]

    }
  },

  methods: {
    buildRowKey(prefix = "row") {
      this.nextRowKey += 1;
      return `${prefix}-${this.nextRowKey}`;
    },

    buildAntFamiliarItem(base = {}) {
      return {
        recordId: base.recordId || null,
        rowKey: base.rowKey || (base.recordId ? `record-${base.recordId}` : this.buildRowKey("new")),
        id: base.id || null,
        value: base.value || '',
        text: base.text || '',
        estado: base.estado || '1',
        familiar: Array.isArray(base.familiar) ? [...base.familiar] : [],
        familiarText: base.familiarText || '',
        inputText: base.inputText || '',
        esDuplicado: !!base.esDuplicado,
      };
    },

    syncSelectedAntecedentes() {
      const selectedByValue = new Map();

      this.antFamiliaresItems
        .filter(item => item.estado === '1')
        .forEach(item => {
          if (!selectedByValue.has(item.value)) {
            selectedByValue.set(item.value, {
              id: item.id,
              value: item.value,
              text: item.text,
            });
          }
        });

      this.antFamiliaresVSelect = Array.from(selectedByValue.values());
    },

    syncEstadoConSeleccion() {
      const seleccionados = this.antFamiliaresVSelect.map(item => item.value);

      // Revisamos lastAntFamiliares
      this.lastAntFamiliares.forEach(item => {
        if (seleccionados.includes(item.value)) {
          item.estado = '1';
        }
      });

      // También para antFamiliaresItems si lo necesitas
      this.antFamiliaresItems.forEach(item => {
        if (seleccionados.includes(item.value)) {
          item.estado = '1';
        } else if (!item.recordId) {
          item.estado = '0';
        }
      });
    },

    editarAntecedente(recordId, value, text) {
      const historial = this.lastAntFamiliares.find(item => item.recordId === recordId);
      if (!historial) return;

      const itemExistente = this.antFamiliaresItems.find(item => item.rowKey === historial.rowKey);

      // Si no existe, agregarlo
      if (!itemExistente) {
        this.antFamiliaresItems.push(this.buildAntFamiliarItem(historial));
        this.syncSelectedAntecedentes();
      }

    },

    duplicarAntecedente(antFamiliar) {
      this.antFamiliaresItems.push(this.buildAntFamiliarItem({
        id: antFamiliar.id,
        value: antFamiliar.value,
        text: antFamiliar.text,
        estado: '1',
        familiar: [],
        inputText: '',
        esDuplicado: true,
      }));
      this.syncSelectedAntecedentes();
    },



    eliminarAntecedente(recordId) {
      this.lastAntFamiliares.forEach(item => {
        if (item.recordId === recordId) { item.estado = '0' }
      })

      this.antFamiliaresItems = this.antFamiliaresItems.filter(item => item.recordId !== recordId);
      this.syncSelectedAntecedentes();

      if (!this.isEditar) {
        this.lastAntFamiliares = this.lastAntFamiliares.filter(item => item.estado === '1');
      }

    },

    getLastFamiliar(id) {
      const matchedItem = this.lastAntFamiliares
        .filter(last => last.id === id)
      if (matchedItem && matchedItem.length > 0) {
        return matchedItem[0].familiarText
      } else return ''

    },
    getLastFamiliarArray(id) {
      const matchedItem = this.lastAntFamiliares
        .filter(last => last.id === id)
      if (matchedItem && matchedItem.length > 0) {
        return matchedItem[0].familiar
      } else return []

    },

    getLastInputText(id) {
      const matchedItem = this.lastAntFamiliares
        .filter(last => last.id === id)
      if (matchedItem && matchedItem.length > 0) {
        return matchedItem[0].inputText
      } else return ''
    },

    async fetchHistorialAntFamiliares(idPaciente) {
      // Limpiar selección previa
      this.antFamiliaresVSelect = [];
      this.loadingHistorial = true;

      if (this.isEditar) {
        this.loadingHistorial = false;
      } else {

        // Obtener historial
        const historialAF = await antFamiliaresService.getAllByPaciente(idPaciente);
        this.loadingHistorial = false;

        // Verificar si hay historial
        if (!historialAF.length) return;

        const ultimoNorefiere = historialAF.filter(a => a.descripcionGeneral !== "No refiere");

        let fechaCitaActual = this.stCitaActual.fechaCita

        const fechaActual = new Date(fechaCitaActual);

        const ultimoValido = ultimoNorefiere.find(a => {
          const fechaComparacion = new Date(a.consultamedica.cita.fechaCita);
          return fechaComparacion < fechaActual;
        });


        if (!ultimoValido) return;

        const idUltimoValido = ultimoValido.consultamedica.id;
        const searchByAtencion = historialAF.filter(a => a.consultamedica.id === idUltimoValido);
        if (!searchByAtencion.length) return;

        // Mapear datos con validación para el split
        this.lastAntFamiliares = searchByAtencion.map(item => ({
          id: item.antescedentesFamiliares.id,
          recordId: item.id,
          text: item.antescedentesFamiliares.descripcion,
          estado: item.estado,
          familiar: typeof item.familiar === 'string' && item.familiar.trim() !== ''
            ? item.familiar.split(', ').map(f => ({ value: f.toLowerCase(), text: f }))
            : [],
          familiarText: item.familiar,
          value: convertToSnakeCase(item.antescedentesFamiliares.descripcion),
          inputText: item.descripcionGeneral,
          esHistorial: true,
          rowKey: `record-${item.id}`,
        }));
      }
    },


    onVisibleBody(value) {
      this.visibleBody = value
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    async getAntFamiliaresOpts() {
      const query = `
        query {
          allAntefam {
            id, descripcion
          }
        }
      `;

      try {
        const response = await axios.post(`${rutas.axios}api`, { query });

        const seenDescriptions = new Set();

        this.antFamiliaresOpts = response.data.data.allAntefam
          .filter(item => {
            if (seenDescriptions.has(item.descripcion)) {
              return false;
            }
            seenDescriptions.add(item.descripcion);
            return true;
          })
          .map(item => ({
            id: item.id,
            text: item.descripcion,
            value: convertToSnakeCase(item.descripcion),
          }));

      } catch (error) {
        console.error("Error fetching Pais:", error);
      }
    },

    copyAS400() {
      copyText(this.summaryText.text)
    },
  },

  watch: {
    antFamiliaresVSelect: {
      deep: true,
      handler(newArray) {
        if (newArray && !newArray.length) { return }

        const idAntFamiliares = newArray.map(item => item.value);
        const rowsActivos = this.antFamiliaresItems.filter(item => item.estado === '1');
        const duplicadosExistentes = rowsActivos.filter(
          item => item.esDuplicado && idAntFamiliares.includes(item.value)
        );

        // Creamos un nuevo arreglo actualizado
        const nuevosItems = idAntFamiliares.map(id => {
          const existente = rowsActivos.find(item => item.value === id && !item.esDuplicado && !item.recordId);
          const existenteRegistro = rowsActivos.find(item => item.value === id && item.recordId);
          const nuevo = newArray.find(item => item.value === id);

          return this.buildAntFamiliarItem({
            recordId: existenteRegistro?.recordId || null,
            rowKey: existenteRegistro?.rowKey,
            id: nuevo?.id || null,
            value: id,
            text: nuevo?.text || '',
            estado: '1',
            familiar: existente?.familiar ?? existenteRegistro?.familiar ?? this.getLastFamiliarArray(nuevo?.id),
            familiarText: existenteRegistro?.familiarText,
            inputText: existente?.inputText ?? existenteRegistro?.inputText ?? this.getLastInputText(nuevo?.id),
          });
        });

        // Reemplazamos todo el arreglo (de forma segura)
        this.antFamiliaresItems = [...nuevosItems, ...duplicadosExistentes];

        this.syncEstadoConSeleccion();

      }
    },

    idPaciente: {
      deep: true,
      handler(newValue) {
        this.fetchHistorialAntFamiliares(newValue);
      }
    },



    // antFamiliaresItems: {
    //   deep: true,
    //   handler(newValue) {
    //     console.log("watcher itemsantfamiliares ejecutado")
    //     let items_filtrados = newValue.filter(item => item.estado === '1')
    //     if (!this.isEditar) {
    //       const filtrados = this.lastAntFamiliares.filter(item => item.estado === '1');
    //       this.dataState.items = [...filtrados, ...items_filtrados];
    //     } else { 
    //       this.dataState.items = [...items_filtrados];
    //     }

    //   }
    // },

    antFamiliaresItems: {
      deep: true,
      handler(newValue) {

        // Filtramos solo los con estado '1'
        let items_filtrados = newValue.filter(item => item.estado === '1');

        if (!this.isEditar) {
          const filtrados = this.lastAntFamiliares.filter(item => item.estado === '1');
          const mergedMap = new Map();

          // Primero los antiguos
          filtrados.forEach(item => {
            mergedMap.set(item.rowKey || item.recordId || item.id, { ...item });
          });

          // Luego los nuevos (sobrescriben si tienen el mismo id)
          items_filtrados.forEach(item => {
            mergedMap.set(item.rowKey || item.recordId || item.id, { ...item });
          });

          // Resultado final, sin duplicados
          this.dataState.items = Array.from(mergedMap.values());
        } else {
          // Si está en modo edición, solo usamos los nuevos
          this.dataState.items = [...items_filtrados];
        }
      }
    },


    lastAntFamiliares: {
      deep: true,
      handler(newValue) {

        if (!newValue) { 
          this.lastAntFamiliares = [];
          return
        }
        if (newValue && newValue.length < 1) return

        this.noRefiere = false;
        if (newValue.length > 0) {
          let combined = [...newValue, ...this.antFamiliaresItems];
          let items_familiares = combined.reduce((acc, current) => {
            const currentKey = current.rowKey || current.recordId || current.id;
            if (!acc.some(item => (item.rowKey || item.recordId || item.id) === currentKey)) {
              acc.push(current);
            }
            return acc;
          }, []);

          this.dataState.items = items_familiares
        }
      }
    },

    //     lastAntFamiliares: {
    //   deep: true,
    //   handler(newValue) {
    //     if (!newValue || !newValue.length) return;
    //     this.noRefiere = false;

    //     if (!this.isEditar) {
    //       const mergedMap = new Map();

    //       // Cargar primero los antecedentes antiguos
    //       newValue.forEach(item => {
    //         mergedMap.set(item.value, { ...item });
    //       });

    //       // Luego los actuales
    //       this.antFamiliaresItems.forEach(item => {
    //         mergedMap.set(item.value, { ...item });
    //       });

    //       this.dataState.items = Array.from(mergedMap.values());
    //     } else {
    //       this.dataState.items = [...this.antFamiliaresItems];
    //     }
    //   }
    // },


    observaciones: {
      deep: true,
      handler(newValue) {
        this.dataState.observaciones = newValue;
        if (!newValue.active) this.observaciones.text = ''
      }
    },

    dataState: {
      deep: true,
      handler(newValue) {

        this.$store.commit("setAntecedentesFamiliares", newValue);
      }
    },

    noRefiere: {
      deep: true,
      handler() {
        if (this.noRefiere === true) {
          this.antFamiliaresItems = [];
          this.antFamiliaresVSelect = [];
          this.observaciones = { active: false, text: '' };
        }
        this.dataState.noRefiere = this.noRefiere;
      }
    },



    stAnteFamiliares: {
      deep: true,
      immediate: true,
      handler(newValue) {
        // Evita bucles o llamadas repetidas innecesarias
        if (this.cargoUnaVez) return;


        if (this.isEditar) {
          if (Array.isArray(newValue) && newValue.length > 0) {
            this.lastAntFamiliares = newValue.map(item => this.buildAntFamiliarItem({
              ...item,
              recordId: item.recordId || item.id,
              rowKey: item.rowKey || `record-${item.recordId || item.id}`,
            }));
            this.cargoUnaVez = true;
            this.loadingHistorial = false;
          }
        }

      }
    },

  },

  computed: {

    ...mapState({
      stAnteFamiliares: state => state.atencionCita?.anamnesis?.antecedentesFamiliares?.items,
      stCitaActual: state => state.atencionCita?.dataCita
    }),

    summaryText() {

      if (this.noRefiere) return { html: 'No refiere', text: 'No refiere' };

      const filteredItems = this.antFamiliaresItems.filter(item => item.inputText.trim() !== '');
      const textArray = filteredItems.map(item => `${item.text}: ${item.familiar ? `(${item.familiar.map(f => f.text).join(', ')})` : ''} ${item.inputText} `);


      if (this.lastAntFamiliares && this.lastAntFamiliares.length) {


        this.lastAntFamiliares.forEach(
          item => {
            const antecedente = `${item.text}: (${item.familiarText})  ${item.inputText}`

            if (this.antFamiliaresItems.find(act => act.recordId === item.recordId)) {

            } else { if (item.estado === '1' || item.estado === 1) { textArray.unshift(antecedente); } }

          }
        );
      }

      if (this.observaciones.active && this.observaciones.text.trim() !== '') {
        textArray.push(`Observaciones adicionales: ${this.observaciones.text}`);
      }

      const textFinish = {
        html: textArray.join('<br>'),
        text: `Antecedentes Familiares:\n` + textArray.join('\n')
      }

      return textFinish
    },
  },

}
</script>
